import { Icon } from '@pairy/pds-react';
import { useAtomValue } from 'jotai';

import { isRightClickAtom } from '../../../../../store/index.atom';

import * as Styled from './index.styles';

const RightMoveEffect = () => {
  const isRightClick = useAtomValue(isRightClickAtom);
  return (
    <Styled.Container
      justifyContent="center"
      alignItems="center"
      className={isRightClick ? 'is-active' : undefined}
    >
      <Icon icon={`ph:caret-right`} size={44} color="white" />
    </Styled.Container>
  );
};

export default RightMoveEffect;
